export default "__VITE_ASSET__U$ojbGpb__"